import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "@phosphor-icons/react";
import api from "@/lib/api";

export default function Payments() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/payments");
        setRows(data);
      } catch {}
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="payments-page">
      <div>
        <div className="text-xs uppercase tracking-widest font-bold text-stone-500">Financial</div>
        <div className="font-display text-2xl font-bold text-stone-900">Payments Ledger</div>
      </div>
      <div className="rounded-xl bg-white border border-stone-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 text-stone-500 text-xs uppercase tracking-widest font-bold">
            <tr>
              <th className="text-left p-3">Ref</th>
              <th className="text-left p-3">Deal</th>
              <th className="text-left p-3">Type</th>
              <th className="text-right p-3">Amount</th>
              <th className="text-center p-3">Status</th>
              <th className="text-right p-3">Date</th>
            </tr>
          </thead>
          <tbody>
            {rows === null && Array.from({ length: 3 }).map((_, i) => (
              <tr key={i}><td colSpan={6} className="p-3"><div className="h-6 shimmer rounded" /></td></tr>
            ))}
            {rows && rows.length === 0 && (
              <tr><td colSpan={6} className="p-10 text-center text-stone-500">No payments yet — payments appear when a deal enters "Payment Secured".</td></tr>
            )}
            {rows && rows.map((p, i) => (
              <motion.tr key={p.id} initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.03 }} className="border-t border-stone-100 hover:bg-stone-50">
                <td className="p-3 font-mono text-xs text-stone-500">{p.gateway_ref}</td>
                <td className="p-3 font-mono text-xs text-stone-700">#{(p.deal_id || "").slice(-8)}</td>
                <td className="p-3 capitalize">{(p.type || "").replace(/_/g, " ")}</td>
                <td className="p-3 text-right font-semibold font-mono">₹{(p.amount || 0).toLocaleString("en-IN")}</td>
                <td className="p-3 text-center">
                  <span className={`inline-flex items-center gap-1 px-2 py-1 rounded text-[11px] font-bold uppercase ${p.status === "settled" ? "bg-emerald-100 text-emerald-800" : "bg-blue-100 text-blue-800"}`}>
                    <ShieldCheck weight="fill" size={12} /> {p.status}
                  </span>
                </td>
                <td className="p-3 text-right text-xs text-stone-500 font-mono">{new Date(p.created_at).toLocaleDateString("en-IN")}</td>
              </motion.tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
